/**
 * Croatian OIB — 11 digits, ISO 7064 MOD 11,10 check digit.
 * Restrictive error 179 rejects a message whose OibOper fails this check, so we
 * validate locally before the network (§5.6).
 */
/** Validates format AND checksum. */
export function isValidOib(oib) {
    if (!/^[0-9]{11}$/.test(oib))
        return false;
    return computeOibCheckDigit(oib.slice(0, 10)) === Number(oib[10]);
}
/**
 * ISO 7064 MOD 11,10 over the first 10 digits.
 * Seed 10; per digit: add, mod 10, map 0->10, double, mod 11.
 * Check digit = (11 - remainder) mod 10.
 */
export function computeOibCheckDigit(first10) {
    if (!/^[0-9]{10}$/.test(first10)) {
        throw new Error("computeOibCheckDigit expects exactly 10 digits");
    }
    let remainder = 10;
    for (const ch of first10) {
        remainder = (remainder + Number(ch)) % 10;
        if (remainder === 0)
            remainder = 10;
        remainder = (remainder * 2) % 11;
    }
    const check = 11 - remainder;
    return check === 10 ? 0 : check;
}
/** Throws a descriptive error rather than returning false. For boot-time config checks. */
export function assertValidOib(oib, label = "OIB") {
    if (!isValidOib(oib)) {
        throw new Error(`${label} "${oib}" is not a valid Croatian OIB (11 digits, ISO 7064 MOD 11,10)`);
    }
}
//# sourceMappingURL=oib.js.map